module.exports = __webpack_public_path__ + "static/media/logo-presensi.ab557fdf.svg";